import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { WorkOrderChangeObjectSelectionItemFilterInput } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderChangeObjectSelectionListGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerWorkOrderChangeObjectSelectionList';

export const useUerWorkOrderChangeObjectSelectionList = () => {
    const dispatch = useDispatch();

    const [
        uerWorkOrderChangeObjectSelectionListData,
        uerWorkOrderChangeObjectSelectionListStatus,
        ,
        uerWorkOrderChangeObjectSelectionListRequest,
    ] = useRequest({
        requestId,
        query: uerWorkOrderChangeObjectSelectionListGql,
        withEffect: false,
    });

    const [uerWorkOrderChangeObjectSelectionListReset] = useResetStoreData({ requestId });

    const uerWorkOrderChangeObjectSelectionListMakeRequest = useCallback(
        (workOrderChangeId: number, constructionTypeId?: number, isIncluded?: boolean) => {
            if (!constructionTypeId) {
                return;
            }

            const where: WorkOrderChangeObjectSelectionItemFilterInput = {
                constructionType: { id: { eq: constructionTypeId } },
                ...(typeof isIncluded === 'boolean' && isIncluded ? { isIncluded: { eq: true } } : {}),
            };

            uerWorkOrderChangeObjectSelectionListReset(undefined);
            dispatch(uerWorkOrderChangeObjectSelectionListRequest({ workOrderChangeId, where }));
        },
        [uerWorkOrderChangeObjectSelectionListRequest, uerWorkOrderChangeObjectSelectionListReset, dispatch],
    );

    return {
        uerWorkOrderChangeObjectSelectionListMakeRequest,
        uerWorkOrderChangeObjectSelectionListData,
        uerWorkOrderChangeObjectSelectionListStatus,
    };
};
